import { Avatar, Button, Dropdown, Input, Menu, message, Modal, Popconfirm, Spin } from "antd";
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import { calculateTimeDifference, StatusCode, UserRoles } from 'common/enums';
import Matiers from "components/matiers";
import { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TeacherCalendarForStudent from 'screens/student/components/calendarTeacher';
import { setIsReservationsUpdated } from 'store/app/appSlice';
import { openProfileDetailsDrawer, setProfileDetailsID, setProfileDetailsType } from 'store/auth/authSlice';
import ClockIcon from "../../../../assets/images/app/clock_icon.svg";
import EllipseTeacherProfileFour from "../../../../assets/images/app/ellipse_teacher_profile4.png";
import EllipseTeacherProfileFive from "../../../../assets/images/app/ellipse_teacher_profile5.png";
import CancelIcon from "../../../../assets/images/app/i_icon.svg";
import MoreOptions from "../../../../assets/images/app/options_icon.svg";
import s from "../assets/calendar.module.css";

type Props = {
  course: any;
  isHistorique: boolean;
  teacher?: any;
};

const CardReservationsStudent: FC<Props> = ({ course, isHistorique, teacher }) => {

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [popconfirmVisible, setPopconfirmVisible] = useState(false);
  /* const [scheduleData, setScheduleData] = useState<any>(null); */
  /* const [openScheduleMeetingDrawer, setOpenScheduleMeetingDrawer] = useState<boolean>(false); */
  const [showDrawerTeacherCalendar, setShowDrawerTeacherCalendar] = useState<boolean>(false);
  const [isZoomMeetingVisible, setIsZoomMeetingVisible] = useState(false);
  const [currentMeetingId, setCurrentMeetingId] = useState('');

  const [isLoadingData, setIsLoadingData] = useState<boolean>(false);
  const [teacherData, setTeacherData] = useState<any>();

  const courseDate = new Date(course?.startDate);

  // Add 1 days to the course date
  const limitDate = new Date(courseDate);
  limitDate.setDate(limitDate.getDate() + 1);

  // Optional: make it end of that day (23:59)
  limitDate.setHours(23, 59, 59, 999);

  // Check if now is after that limit
  const isPast = new Date() > limitDate;

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1050);
  };
  window.addEventListener('resize', handleResize);

  const [openMobileModal, setOpenMobileModal] = useState(false);

  const handleMenuClick = (e: any) => {
    if (e.key === "0") {
      if (isMobile) {
        e.preventDefault();
        setOpenMobileModal(true);
      } else {
        if (course?.commonLink) {
          window.open(course.commonLink, "_blank", "noopener,noreferrer");
        }
        else {
          window.open(course.studentLink, "_blank", "noopener,noreferrer");
        }
      }
    }
    else if (e.key === "1") {
      setPopconfirmVisible(true);
      setDropdownVisible(false);
    }
    else if (e.key === "2") {
      setDropdownVisible(false);
      setIsLoadingData(true);
      checkScheduleMeeting();
    }
  };

  const handleStatMeeting = () => {
    setDropdownVisible(false);
    handleMeetingClick();
  };

  const handleConfirm = () => {
    setPopconfirmVisible(false);
    setIsLoadingData(true);
    checkCancelMeeting();
  };

  const handleCancel = () => {
    setPopconfirmVisible(false);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const [isScheduleMessageModalOpen, setIsScheduleMessageModalOpen] = useState(false);
  const [cancelMessage, setCancelMessage] = useState("");
  const [scheduleMessage, setScheduleMessage] = useState("");

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancelModal = () => {
    setIsModalOpen(false);
  };

  const handleCancelScheduleModal = () => {
    setIsScheduleModalOpen(false);
  };

  const handleCancelMeetModal = () => {
    setIsCancelModalOpen(false);
  };

  const handleCancelScheduleMessageModal = () => {
    setIsScheduleMessageModalOpen(false);
  };

  const handleScheduleMeeting = () => {
    setIsModalOpen(false);
    setIsLoadingData(true);
    checkScheduleMeeting();
  };

  const menu = (
    user?.roles?.includes(UserRoles?.STUDENT) ? <Menu onClick={handleMenuClick}>
      <Menu.Item key="0">Rejoindre le meet</Menu.Item>
      {course?.typeCreneaux !== "collectif" && <Menu.Item key="1">Annuler le meet</Menu.Item>}
      {course?.codeCoupon?.couponType !== "FREE_CLASS" && course?.typeCreneaux !== "collectif" && <Menu.Item key="2">Replanifier le meet</Menu.Item>}
    </Menu> : <Menu onClick={handleMenuClick}>
      {course?.typeCreneaux !== "collectif" && <Menu.Item key="1">Annuler le meet</Menu.Item>}
      {course?.codeCoupon?.couponType !== "FREE_CLASS" && course?.typeCreneaux !== "collectif" && <Menu.Item key="2">Replanifier le meet</Menu.Item>}
    </Menu>
  );

  const cancelMeeting = async () => {
    setIsLoading(true);
    try {
      if (cancelMessage !== "") {
        const response = await AUTH_SERVICES.cancelMeeting(course?._id, cancelMessage, user?.roles?.includes(UserRoles?.STUDENT) ? user?._id : course?.studId?._id);
        if (response?.statusCode === StatusCode.CREATED) {
          message.success({
            content: "Meet annulé ",
          });
          setTimeout(() => {
            dispatch(setIsReservationsUpdated(true));
          }, 2000);
          setIsLoading(false);
          setIsModalOpen(false);
        }
        else {
          message.warning({
            content: "Ooops, erreur lors de l'annulation",
          });
          setIsLoading(false);
        }
      }
      else {
        message.warning({
          content: "Ooops, entre le message de l'annulation",
        });
        setIsLoading(false);
      }
    } catch (error: any) {
      message.warning({
        content: error?.response?.data?.message,
      });
      setIsLoading(false);
    }
  }

  const sendScheduleMeetingMessage = async () => {
    localStorage.setItem("scheduleMessage", scheduleMessage);
    localStorage.setItem("level", course?.level?._id);
    setIsLoading(false);
    setIsScheduleMessageModalOpen(false);
    getTeacherData(course?.profId?._id || teacher?._id);
  }

  const handleMeetingClick = () => {
    if (!course?.studentLink) {
      message.error("Lien de réunion non trouvé pour ce cours");
      return;
    }

    // Extract meeting ID from Zoom link - handle multiple URL formats
    let meetingId;
    try {
      const url = new URL(course.studentLink);
      // Handle different Zoom URL formats
      if (url.pathname.includes('/j/')) {
        meetingId = url.pathname.split('/j/')[1]?.split('?')[0];
      } else if (url.pathname.includes('/s/')) {
        meetingId = url.pathname.split('/s/')[1]?.split('?')[0];
      } else {
        // Try to find any number sequence that could be a meeting ID
        meetingId = url.pathname.match(/\d{10,11}/)?.[0];
      }

      if (!meetingId) {
        throw new Error('Meeting ID not found in URL');
      }

      setCurrentMeetingId(meetingId);
      setIsZoomMeetingVisible(true);

    } catch (error) {
      message.error("Format du lien de réunion invalide");
    }
  };

  const getTeacherData = async (teacherId: string) => {
    setIsScheduleModalOpen(false);
    setIsLoadingData(true);
    try {
      const response = await AUTH_SERVICES.getTeacherData(user?.roles?.includes(UserRoles?.STUDENT) ? user?._id : course?.studId?._id, teacherId);
      setTeacherData(response?.data);

      setTimeout(() => {
        setIsLoadingData(false);
        setIsModalOpen(false);
        setShowDrawerTeacherCalendar(true);
      }, 2000);
    } catch (error: any) {
      setIsLoadingData(false);
    }
  };

  const handleProfileDetails = () => {
    dispatch(setProfileDetailsID(course?.profId?.uid || teacher?.uid));
    dispatch(setProfileDetailsType("teacher"));
    dispatch(openProfileDetailsDrawer());
  }

  const checkScheduleMeeting = async () => {
    setIsLoading(true);
    try {
      const response = await AUTH_SERVICES.checkScheduleMeeting(user?.roles?.includes(UserRoles?.STUDENT) ? user?._id : course?.studId?._id, course?._id);
      if (response?.statusCode === StatusCode.OK) {
        if (response?.data) {
          setIsScheduleModalOpen(true);
          setIsLoadingData(false);
        }
        else {
          localStorage.setItem("level", course?.level?._id);
          getTeacherData(course?.profId?._id || teacher?._id);
        }
      }
      else {
        message.warning({
          content: response?.data?.message,
        });
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Erreur interne du serveur. Veuillez réessayer plus tard.";

      message.warning({
        content: errorMessage,
      });
    }
    finally {
      setIsLoading(false);
    }
  }

  const checkCancelMeeting = async () => {
    setIsLoading(true);
    try {
      const response = await AUTH_SERVICES.checkCancelMeeting(user?.roles?.includes(UserRoles?.STUDENT) ? user?._id : course?.studId?._id, course?._id);
      if (response?.statusCode === StatusCode.OK) {
        if (response?.data) {
          setIsCancelModalOpen(true);
          setIsLoadingData(false);
        }
        else {
          setIsCancelModalOpen(false);
          setIsLoadingData(false);
          showModal();
        }
      }
      else {
        message.warning({
          content: response?.data?.message,
        });
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Erreur interne du serveur. Veuillez réessayer plus tard.";

      message.warning({
        content: errorMessage,
      });
    }
    finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      {!isMobile && <img src={EllipseTeacherProfileFour} height={106} style={{ position: "absolute", top: "25%", left: "0px", zIndex: "-1" }}></img>}
      {!isMobile && <img src={EllipseTeacherProfileFive} height={54} style={{ position: "absolute", top: "35%", left: "94%", zIndex: "-1" }}></img>}
      <div className={`${course?.status === "CANCELED" ? s.classeCardDeleted : course?.codeCoupon ? s.classeCardCoupon : s.classeCard}`}>
        <div className={course?.codeCoupon ? s.cardClassBoxCoupon : s.cardClassBox}>
          <div className={s.avatarNameBox} onClick={handleProfileDetails}>
            <Avatar.Group
              maxCount={3}
              maxStyle={{
                color: "#f56a00",
                backgroundColor: "#fde3cf",
              }}
              style={{ marginRight: isMobile ? "0px" : "5px", cursor: "pointer" }}
            >
              <Avatar
                size={45}
                style={{ backgroundColor: "#FFF2E0", boxShadow: "0px 3px 6px #00000029" }}
                src={course?.profId?.profile || teacher?.profile}
              />
            </Avatar.Group>
            <div style={{ position: "relative", left: isMobile ? "0px" : "15px", fontSize: isMobile ? "0.8em" : "13px", textTransform: "capitalize", cursor: "pointer" }}>
              {teacher ? teacher?.firstname + " " + teacher?.lastname : course?.profId?.firstname + " " + course?.profId?.lastname}
            </div>
          </div>
          {isMobile && course?.typeCreneaux !== "collectif" && course?.topic?.title && course?.level?.title && <Matiers
            cours={course?.topic?.title || "null"}
            level={course?.level?.title || "null"}
          />}
          <div className={s.detailsBox}>
            <div className={s.timeBox}>
              {!isMobile && <img src={ClockIcon} height={15} style={{ marginRight: "10px" }}></img>}
              <div className={s.times}>
                <span className={s.time}>{isMobile && <img src={ClockIcon} height={10} style={{ marginRight: "5px" }}></img>} De {course?.range[0]} à {course?.range[course?.range?.length - 1]}</span>
                <span className={s.timeDescription}>Séance de “{calculateTimeDifference(course?.range[0], course?.range[course?.range.length - 1])}”</span>
              </div>
            </div>
            {!isMobile && course?.typeCreneaux !== "collectif" && course?.topic?.title && course?.level?.title && <div style={{ width: "auto" }}>
              <Matiers
                cours={course?.topic?.title || "null"}
                level={course?.level?.title || "null"}
              />
            </div>}
            {course?.typeCreneaux !== "collectif" && <div className={s.amountBox}>
              {!teacher && <span style={{ width: "auto" }}>Séance réservée pour</span>}
              {course?.codeCoupon && (course?.codeCoupon?.couponType === "FREE_CLASS" || course?.codeCoupon?.couponType === "FREE_LINK_DISCOUNT") ? <div className={s.priceBox}>Cours gratuit</div> : <div className={s.priceBox}>{(course?.byCredits === "oui" || course?.byCredits === "true") ? course?.creditedValue + " Crédit" : course?.price + " €"}</div>}
            </div>}
            {course?.typeCreneaux === "collectif" && <div className={s.amountBox}>
              {!teacher && <span style={{ width: "auto" }}>Séance réservée pour</span>}
              {course?.pricePerStudent ? <div className={s.priceBox}>{course?.pricePerStudent} {course?.pricePerStudent >= 2 ? "Crédits" : "Crédit"}</div> : <div className={s.priceBox}>{course?.price} {course?.price >= 2 ? "Crédits" : "Crédit"}</div>}
            </div>}

            {course?.classeTitle && <div style={{ marginLeft: "10px", height: 35, background: "#FFF", borderRadius: "12px", border: "1px dashed #707070", display: "flex", alignItems: "center", justifyContent: "center", paddingLeft: "5px", paddingRight: "5px" }}>{course?.classeTitle}</div>}
          </div>

          {isLoading || isLoadingData ? <div>
            <Spin />
          </div> : !isHistorique && <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
            {/* {course?.status !== "CANCELED" && <a href={course?.typeCreneaux === "collectif" ? course?.commonLink : course?.studentLink} target="_blank"><Button className={s.meetButton}>
              {!isMobile && "Rejoindre le meet"} <img src={MeetIcon} height={isMobile ? 14 : 18} style={{ marginLeft: isMobile ? "0px" : "5px" }}></img>
            </Button></a>} */}
            {!isMobile && course?.status !== "CANCELED" && course?.typeCreneaux !== "collectif" && <Popconfirm
              title={`Veux-tu annuler ce meet?`}
              visible={popconfirmVisible}
              onVisibleChange={(visible) => {
                if (!isLoading) {
                  setPopconfirmVisible(visible);
                }
              }}
              onConfirm={handleConfirm}
              onCancel={handleCancel}
              okText="Oui"
              cancelText="Non"
            >
              <Button type="primary" />
            </Popconfirm>}
            {course?.status !== "CANCELED" && <Dropdown overlay={menu} visible={isPast ? false : dropdownVisible} onVisibleChange={setDropdownVisible} overlayStyle={{ border: "none" }}>
              <Button disabled={isPast} onClick={() => setDropdownVisible(true)} className={isPast ? s.disabledMeetButton : s.meetButton}>
                <img src={MoreOptions} height={isMobile ? 14 : 18} style={{ marginRight: 10 }}></img>
                Options
              </Button>
            </Dropdown>}
            {course?.status === "CANCELED" && <div className={s.cancelBox}>
              <div className={s.horizontalLineDeleted}></div>
              <span>
                <img src={CancelIcon} height={isMobile ? 10 : 18} style={{ marginRight: "5px", marginLeft: isMobile ? "0px" : "20px" }}></img>
                Meet annulé
              </span>
            </div>}
          </div>}
        </div>
      </div>

      {isMobile && <Popconfirm
        title={`Veux-tu annuler ce meet?`}
        visible={popconfirmVisible}
        onVisibleChange={(visible) => {
          if (!isLoading) {
            setPopconfirmVisible(visible);
          }
        }}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        okText="Oui"
        cancelText="Non"
      >
        <Button type="primary" />
      </Popconfirm>}

      <Modal
        visible={openMobileModal}
        onCancel={() => setOpenMobileModal(false)}
        footer={null}
        centered
      >
        <div style={{ textAlign: "center", padding: "10px" }}>
          <h3 style={{ marginBottom: "10px" }}>
            ⚠️ Accès non disponible sur mobile
          </h3>

          <p style={{ color: "#665" }}>
            Vous ne pouvez pas participer à ce cours depuis votre téléphone.
            <br />
            Merci d'utiliser un ordinateur.
          </p>

          <Button
            type="primary"
            style={{ marginTop: "15px" }}
            onClick={() => setOpenMobileModal(false)}
          >
            OK
          </Button>
        </div>
      </Modal>

      {/* <ScheduleMeeting setScheduleData={setScheduleData} setOpenScheduleMeetingDrawer={setOpenScheduleMeetingDrawer} openScheduleMeetingDrawer={openScheduleMeetingDrawer} id={course?._id} /> */}
      <TeacherCalendarForStudent
        open={showDrawerTeacherCalendar}
        setOpen={setShowDrawerTeacherCalendar}
        currentTeacher={teacherData}
        currentReservation={course}
      />

      {/* Cancel Meet */}
      <Modal
        title={null}
        visible={isCancelModalOpen}
        onCancel={handleCancelMeetModal}
        footer={null}
        centered={true}
        closable={false}
      >
        <div style={{
          border: '1px solid #000',
          borderRadius: 8,
          padding: 16,
          backgroundColor: '#FFF'
        }}>
          <p style={{ marginBottom: 24 }}>
            <strong>Attention :</strong> Ce cours sera annulé à moins de 2 heures.
            <br />
            Es-tu sûr(e) de vouloir continuer la démarche d'annulation ?
          </p>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button className={s.scheduleButton} loading={isLoadingData} onClick={() => setIsCancelModalOpen(false)}>
              Non, revenir
            </Button>
            <Button className={s.cancelButton} loading={isLoading || isLoadingData} onClick={() => { setIsCancelModalOpen(false); setIsModalOpen(true) }}>
              Oui, continuer
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        title={
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
            <Avatar.Group
              maxCount={3}
              maxStyle={{
                color: "#f56a00",
                backgroundColor: "#fde3cf",
              }}
              style={{ marginRight: "5px" }}
            >
              <Avatar
                size={45}
                style={{ backgroundColor: "#FFF2E0", boxShadow: "0px 3px 6px #00000029" }}
                src={user?.profile}
              />
            </Avatar.Group>
            Annulation de meet
          </div>
        }
        visible={isModalOpen}
        onCancel={handleCancelModal}
        footer={null}
      >
        <div style={{ marginBottom: "16px", textTransform: "capitalize" }}>
          <strong>
            {new Intl.DateTimeFormat("fr-FR", {
              weekday: "long",
              day: "numeric",
              month: "long",
              year: "numeric",
            }).format(new Date(course?.day))}
          </strong>
        </div>
        <div style={{ marginBottom: "8px" }}>
          <span>Message pour {course?.profId?.firstname || teacher?.firstname}</span>
        </div>
        <Input.TextArea
          rows={3}
          placeholder="J'annule le meet parce que..."
          value={cancelMessage}
          onChange={(e) => setCancelMessage(e.target.value)}
          style={{ borderRadius: "10px" }}
          required={true}
        />
        <div
          style={{
            marginTop: "24px",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: isMobile ? "center" : "space-between",
          }}
        >
          {course?.codeCoupon?.couponType !== "FREE_CLASS" && <Button className={s.scheduleButton} loading={isLoadingData} onClick={handleScheduleMeeting}>
            Reprogrammer plutôt
          </Button>}
          <Button className={s.cancelButton} loading={isLoading || isLoadingData} onClick={cancelMeeting}>
            Confirmer l'annulation
          </Button>
        </div>
      </Modal>

      {/* Schedule */}
      <Modal
        title={null}
        visible={isScheduleModalOpen}
        onCancel={handleCancelScheduleModal}
        footer={null}
        centered={true}
        closable={false}
      >
        <div style={{
          border: '1px solid #000',
          borderRadius: 8,
          padding: 16,
          backgroundColor: '#FFF'
        }}>
          <p style={{ marginBottom: 24 }}>
            <strong>Attention :</strong> Ce cours sera reprogrammé.
            <br />
            Es-tu sûr de vouloir continuer la démarche de reprogrammation ?
          </p>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button className={s.scheduleButton} loading={isLoadingData} onClick={() => setIsScheduleModalOpen(false)}>
              Non, revenir
            </Button>
            <Button className={s.cancelButton} loading={isLoading || isLoadingData} onClick={() => { setIsScheduleModalOpen(false); setIsScheduleMessageModalOpen(true) }}>
              Oui, continuer
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        title={
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
            <Avatar.Group
              maxCount={3}
              maxStyle={{
                color: "#f56a00",
                backgroundColor: "#fde3cf",
              }}
              style={{ marginRight: "5px" }}
            >
              <Avatar
                size={45}
                style={{ backgroundColor: "#FFF2E0", boxShadow: "0px 3px 6px #00000029" }}
                src={user?.profile}
              />
            </Avatar.Group>
            Reprogrammation de meet
          </div>
        }
        visible={isScheduleMessageModalOpen}
        onCancel={handleCancelScheduleMessageModal}
        footer={null}
      >
        <div style={{ marginBottom: "16px", textTransform: "capitalize" }}>
          <strong>
            {new Intl.DateTimeFormat("fr-FR", {
              weekday: "long",
              day: "numeric",
              month: "long",
              year: "numeric",
            }).format(new Date(course?.day))}
          </strong>
        </div>
        <div style={{ marginBottom: "8px" }}>
          <span>Motif de la reprogrammation</span>
        </div>
        <Input.TextArea
          rows={3}
          placeholder="Je reprogramme le meet parce que..."
          value={scheduleMessage}
          onChange={(e) => setScheduleMessage(e.target.value)}
          style={{ borderRadius: "10px" }}
          required={true}
        />
        <div
          style={{
            marginTop: "24px",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: isMobile ? "center" : "space-between",
          }}
        >
          <Button className={s.scheduleButton} loading={isLoadingData} onClick={() => setIsScheduleMessageModalOpen(false)}>
            Annuler
          </Button>
          <Button className={s.cancelButton} loading={isLoading || isLoadingData} onClick={() => sendScheduleMeetingMessage()}>
            Confirmer
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default CardReservationsStudent;
